import {useStyles} from './ElementRow.style';
import React from "react";
import ContactPageIcon from '@mui/icons-material/ContactPage';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip } from '@mui/material';
import ElementRowProperties from "./ElementRowProperties";
import clsx from "clsx";

const ContactElementRow: React.FC<ElementRowProperties> = ({
    element,
    onSelect,
    className,
    selected,
    serviceName
}) => {
    const classes = useStyles();

    const serviceEnabled =
        !serviceName || element?.geo?.enableServiceNames?.includes(serviceName);

    const handleClick = () => {
        if (!serviceEnabled) return;
        onSelect(element);
    };

    return (
        <div
            className={clsx(
                classes.element_row_container,
                !serviceEnabled && classes.inative,
                className,
                selected && classes.active
            )}
            onClick={handleClick}
        >
            <div className={classes.icon_info}>
                <ContactPageIcon />
            </div>

            <div className={classes.text_container}>
                <div>Nombre: <b>{element.name} {element.lastName}</b></div>
            </div>

            {!serviceEnabled && (
                <Tooltip title="Servicio indisponible para el municipio del destinatario.">
                    <InfoOutlinedIcon
                        style={{
                            fontSize: 20,
                            marginLeft: 'auto',
                            marginRight: '10px',
                            alignSelf: 'center',
                        }}
                    />
                </Tooltip>
            )}
        </div>
    );
};

export default ContactElementRow;
